module.exports = __webpack_public_path__ + "assets/img/slogan-336979ae.png";